import styled from 'styled-components';

import Colours from '/shared/styled/Colours';

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: ${Colours.whiteDark1};
  padding: 8rem;

  &::after {
    content: '';
    position: absolute;
    top: 3rem;
    bottom: 3rem;
    left: 3rem;
    right: 3rem;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23666' stroke-width='4' stroke-dasharray='6%2c12' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    pointer-events: none;
  }
`;
